import styled from "styled-components"

const EncloseFloats = styled.div`
  display: inline-block;
  width: 100%;
`

export default EncloseFloats
